import { FallbackRender } from '@sentry/react';

export const ErrorFallback: FallbackRender = (props) => {
  const { error, componentStack } = props;
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{(error as any)?.message}</pre>
      <pre>{componentStack}</pre>
    </div>
  );
};
